import { TranslatePipe } from '@ngx-translate/core';

import { Component } from '@angular/core';

import { ButtonVariant, ButtonComponent } from '@/app/shared/components/ui/button/button.component';
import {
  DialogComponent,
  BaseDialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogContentComponent,
} from '@/app/shared/components/ui/dialog';

interface ConfirmInterface {
  title: string;
  text?: string;
  cancelLabel?: string;
  applyLabel?: string;
  applyLabel2?: string;
  applyButtonVariant?: ButtonVariant;
  textType?: 'danger' | 'default';
  variant?: 'danger' | 'default';
  showCancelButton?: boolean;
  buttonsJustify?: 'start' | 'center' | 'end' | 'space-between';
}

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [
    DialogComponent,
    DialogHeaderComponent,
    DialogContentComponent,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent extends BaseDialogComponent<ConfirmInterface, boolean | string> {
  constructor() {
    super();

    this.dialogRef.updateSize('450px');
  }

  protected apply(type?: string) {
    if (type) {
      this.dialogRef.submit(type);
    } else {
      this.dialogRef.submit(true);
    }
  }
}
